interface FetchErrorObject {
    ErrorCode: number;
    ErrorDescription: string;
    URL: string
}

export default class CustomFetchError extends Error {
    ErrorCode: number;
    ErrorDescription: string;
    URL: string;

    constructor(fetchErrorObject: FetchErrorObject, options?: { cause?: unknown }) {
        super(JSON.stringify(fetchErrorObject, null, 4));
        if (options?.cause !== undefined) (this as any).cause = options.cause;
        this.ErrorCode = fetchErrorObject.ErrorCode
        this.ErrorDescription = fetchErrorObject.ErrorDescription
        this.URL = fetchErrorObject.URL
    }
}